import React from 'react';

import VehicleEditForm from '@components/form/VehicleEditForm';

const VehicleCreateForm = (): JSX.Element => <VehicleEditForm showFormSubmitButton />;

export default React.memo(VehicleCreateForm);
